module.exports = __webpack_public_path__ + "img/img4.d1f1be8f.png";